import Vue from 'vue'
import Router from 'vue-router'
import gameDetail from '@/components/gameDetail'
import gameDetailPhone from '@/components/gameDetailPhone'

let isPhone = function(){
  let userAgentInfo = navigator.userAgent
  let Agents = ["Android","iPhone","SymbianOS","Windows Phone","iPad","iPod"]
  let flag = true;
  for(let v= 0;v<Agents.length;v++){
    if (userAgentInfo.indexOf(Agents[v])>=0){
      flag = false
      break
    }
  }
  return flag
}
let isPc = isPhone()
Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'gameDetail',
      component: !isPc?resolve=>require(['@/components/gameDetailPhone'],resolve):resolve=>require(['@/components/gameDetail'],resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js